import * as actions from './actions'
import { get } from 'lodash'
import { path, pathOr } from 'ramda'
import { BillingCollectionMethod, CustomerSegment, DefaultPlanName } from 'constants/dealConstants'

const getRoot = state => state.billing

export const getCoupon = state => getRoot(state).coupon
export const getPlan = state => getRoot(state).plan
const getBillingDealStatus = state => getRoot(state).billingDealStatus
const getActivateDealStatus = state => getRoot(state).activateDealStatus
export const isBillingDealEmpty = state => Object.keys(getRoot(state).billingDeal).length === 0
export const isBillingDealValid = state => get(getDeal(state), 'status', '') === "OPEN"
export const getBillingDealLoading = state => getBillingDealStatus(state) === actions.fetchDealPending.toString()
export const getBillingDealSucceeded = state => getBillingDealStatus(state) === actions.fetchDealSuccess.toString()
export const getBillingDealFailed = state => getBillingDealStatus(state) === actions.fetchDealFailed.toString()
export const getDeal = state => getRoot(state).billingDeal
export const getPlanDisplayName = state => pathOr(DefaultPlanName, ['planDisplayName'], getDeal(state))
export const getDealRep = state => getDeal(state).salesRep
export const getCustomerInfo = state => getDeal(state).customerInfo
export const getActivateDealSucceeded = state => getActivateDealStatus(state) === actions.activateDealSuccess.toString()
export const getActivateDealFailed = state => getActivateDealStatus(state) === actions.activateDealFailed.toString()
export const isBillingDealUpgrade = state => getDeal(state).upgrade
export const activateDealErrorMessage = state => getRoot(state).activateDealErrorMessage
export const isInvoicedDeal = state => path(['billingCollectionMethod'], getCustomerInfo(state)) === BillingCollectionMethod.MANUAL
export const getCustomerSegment = state => pathOr(CustomerSegment.SMB, ['segment'], getCustomerInfo(state))



// WEBPACK FOOTER //
// ./src/modules/billing/selectors.js